import React from "react";

import { DEFAULT_CARD_HEIGHT, TAG } from "config/constants";
import TagStreamWrapper from "stream/containers/TagStreamWrapper";
import Stream from "stream/containers/Stream";
import FullStoryCard from "cards/containers/FullStoryCard";
import PromoStreamCap from "stream/components/PromoStreamCap";
import Helmet from "react-helmet-async";
import IssuesModule from "stream/containers/IssuesModule";

import image from "assets/img/davos-deep-dive.png";
import ogImage from "assets/img/davos-deep-dive-social.jpg";

export default function DavosTagStream() {
  const StreamShoe = () => (
    <IssuesModule
      boxes={[
        {
          name: "Economy",
          tagSlug: "economy",
          backgroundColor: "#d9de47",
        },
        {
          name: "Geopolitics",
          tagSlug: "global-politics",
          backgroundColor: "#9dbbf2",
        },
        {
          name: "Inequality",
          tagSlug: "economic-inequality",
          backgroundColor: "#e64f1d",
        },
        {
          name: "Globalization",
          tagSlug: "tradeglobalization",
          backgroundColor: "#414141",
        },
      ]}
    />
  );

  return (
    <>
      <Helmet>
        <meta property="og:image" content={ogImage} />
      </Helmet>
      <TagStreamWrapper slug={TAG.DAVOS.slug}>
        {({ streamParams }) => (
          <>
            <PromoStreamCap
              promo={{
                title: "A new political and economic order is emerging",
                content: (
                  <span>
                    Read our full report below and{" "}
                    <a
                      className="gtm-promo-stream-cap-content-link"
                      href="https://signup.axios.com/2019/am.html?source=axios&medium=referral&campaign=stream_cap_promo_link&page=axios"
                    >
                      sign up for Axios AM{" "}
                    </a>
                    to get deep dives into the biggest topics impacting the
                    future.
                  </span>
                ),
                contentForAnalytics:
                  "Read our full report below and sign up for Axios AM to get deep dives into the biggest topics impacting the future.",
                image: image,
              }}
            />
            <Stream
              {...streamParams}
              defaultCardHeight={DEFAULT_CARD_HEIGHT.FULL_STORY_CARD}
              contentComponent={FullStoryCard}
              streamShoeComponent={StreamShoe}
            />
          </>
        )}
      </TagStreamWrapper>
    </>
  );
}
